/*
 * File: cell-action-base.ts
 * Created: 2025-12-06 13:31:55
 * Author: Val Liu <valuis0429@gmail.com>
 * -----
 * Last Modified: 2025-12-10 19:31:03
 * Modified By: Val Liu <valuis0429@gmail.com>
 */

import { Component, Inject, Prop } from "vue-property-decorator";
import { IQuickUnit } from "@root/core/utilities/quick-helper";
import BaseTableBodyCell from "@root/components/table/core/lib/base-table-body-cell/base-table-body-cell";
import { ITableActionContext } from "@root/components/table/core/table";

type ListenerMap = Record<string, Function | Function[]>;

@Component
export default class CellActionBase extends BaseTableBodyCell {
    @Prop({ type: Object, required: true })
    quick!: IQuickUnit;

    @Prop({ type: String, default: "" })
    icon!: string;

    // 接收 inDropdown 屬性，判斷顯示模式
    @Prop({ type: Boolean, default: false })
    inDropdown!: boolean;

    @Prop({ type: [Boolean, Function], default: undefined })
    visible!: boolean | ((row: any) => boolean) | undefined;

    private localVisible: boolean | ((row: any) => boolean) = true;

    protected setVisible(value: boolean | ((row: any) => boolean)) {
        this.localVisible = value;
    }

    get isVisible(): boolean {
        const source =
            this.visible !== undefined ? this.visible : this.localVisible;
        if (typeof source === "function") {
            return !!source(this.row);
        }
        return source !== false;
    }

    // 取得 Bootstrap 標準文字顏色 class
    get textClass(): string {
        return `text-${this.variant}`;
    }

    @Inject({ from: "iv-table-action-context", default: null })
    tableActionContext!: ITableActionContext | null;

    /**
     * 給 directive 的 updated 回呼
     * 表單 updated -> 讓 table reload
     */
    doTableReload() {
        this.tableActionContext?.reload();
    }
}
